import { Alert, Col, Row } from "antd";
import { FC } from "react";
import ConflictAlert from "../../../../components/conflictAlert";
import RelatedCaseAlert from "../../../../components/relatedCaseAlert";
import TaxCaseStore from "../../../../contexts/taxCaseStore";
import _t from "../../../../lang/translate";
import format from "../../../../utilities/formatNumbers";
import { getVersionStatus } from "../calc/taxCalcService";
import TaxFlow from "../taxFlow/taxFlow";
import TaxVehicleEdit from "./taxVehicleEdit/taxVehicleEdit";
import TaxFlowWraper from "../taxFlow/taxFlowWrapper";

const TaxCaseEdit: FC = () => {
  const { taxCase } = TaxCaseStore.useContainer();
  const caseCalculatedAtYear = new Date(taxCase.calculation?.createdAt ?? '').getFullYear()
  const versionStatus = getVersionStatus(taxCase.version, caseCalculatedAtYear);
  return (
    <Row align="top" gutter={24}>
      <Col span={24}>
        {taxCase.relatedResellerTaxCase && (
          <RelatedCaseAlert linkedCase={taxCase.relatedResellerTaxCase} />
        )}
        {taxCase.relatedCases && (
          <ConflictAlert conflictedCases={taxCase.relatedCases} />
        )}
        {taxCase.flags.accepted && (
          <Alert
            className="mb-1"
            message={taxCase.expectedRegistrationDate ? `Forventet indregistrering: indtil d. ${format.date(taxCase.expectedRegistrationDate)}` : "Forventet indregistrering: Ukendt"}
            type="info"
            closable
          />
        )}
        {versionStatus !== "latest" && (
          <Alert
            banner
            type={versionStatus === "expired" ? "error" : "info"}
            message={_t(
              versionStatus === "expired"
                ? "msg.cannot_calculate"
                : "calc_updated"
            )}
            closable={versionStatus !== "expired"}
            className="mb-2"
          />
        )}
      </Col>
      <Col span={24}>
        <Row gutter={24}>
          <Col lg={{ span: taxCase.client?.dealerNote2 ? 12 : 24 }} span={24}>
            {taxCase.client?.dealerNote && (
              <Alert
                type={"info"}
                message={taxCase.client.dealerNote}
                className="mb-2"
              />
            )}
          </Col>

          <Col lg={{ span: taxCase.client?.dealerNote ? 12 : 24 }} span={24}>
            {taxCase.client?.dealerNote2 && (
              <Alert
                type={"info"}
                message={taxCase.client.dealerNote2}
                className="mb-2"
              />
            )}
          </Col>
        </Row>
      </Col>
      <Col span={24} >
        <Row align="top" gutter={24} className="tax-case-main-row">
          <Col className="tax-case-vehicle-col">
            {taxCase.importantNote && (
              <Alert
                className="mb-2"
                message={taxCase.importantNote}
                type="warning"
                closable
              />
            )}
            <TaxVehicleEdit />
          </Col>
          <Col className="tax-case-flow-col">
            <TaxFlowWraper />
          </Col>
        </Row>
      </Col>
      {/* <Col */}
      {/*   xxl={{ span: 8, order: 3 }} */}
      {/*   xl={{ span: 12, order: 2 }} */}
      {/*   xs={{ span: 24, order: 2 }} */}
      {/**/}
      {/* > */}
      {/*   <TaxActions /> */}
      {/* </Col> */}
    </Row>
  );
};

export default TaxCaseEdit;
